module.exports = __webpack_public_path__ + "static/media/settings.86ff38b1.svg";